import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

function SectionIntro({ eyebrow, title, description, light = false, centered = false }) {
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      className={`section-intro ${centered ? 'centered' : ''} ${light ? 'light' : ''}`}
      initial={reduceMotion ? false : { opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-100px' }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    >
      <span className="eyebrow">{eyebrow}</span>
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </motion.div>
  );
}

export default SectionIntro;